import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import styled from 'styled-components';

import { Button, media } from '@/shared/components';
import { useIsDesktop } from '@/shared/hooks/use-is-desktop';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { ReturnToEditingModalProps } from '@/widgets/modals/types';

import { ModalContainerV2 } from '../containers/ModalContainerV2';

export const ReturnToEditingModal: FC<ReturnToEditingModalProps> = ({
  onConfirm,
  fromExecution,
}) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'returnToEditing' });
  const isDesktop = useIsDesktop();
  const modals = useModalsStore();

  const handleSubmit = () => {
    modals.closeModal();
    onConfirm();
  };

  return (
    <ModalContainerV2 title={t(fromExecution ? 'altTitle' : 'title')} pinBottom={true}>
      <DescriptionWrapper>{t(fromExecution ? 'altDescription' : 'description')}</DescriptionWrapper>
      <ButtonWrapper>
        {fromExecution && (
          <Button
            type="default"
            text={t('cancelButton')}
            isBlock={!isDesktop}
            onClick={modals.closeModal}
          />
        )}
        <Button
          text={t(fromExecution ? 'altConfirmButton' : 'confirmButton')}
          isBlock={!isDesktop}
          onClick={handleSubmit}
        />
      </ButtonWrapper>
    </ModalContainerV2>
  );
};

const DescriptionWrapper = styled.div`
  padding: 24px 0px;
  white-space: pre-line;

  ${media.mobile} {
    padding: 16px 0px 10px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  gap: 16px;
`;
